import { render } from "./SectionContact2.vue?vue&type=template&id=0571bdcd&scoped=true"
import script from "./SectionContact2.vue?vue&type=script&lang=js"
export * from "./SectionContact2.vue?vue&type=script&lang=js"

import "./SectionContact2.vue?vue&type=style&index=0&id=0571bdcd&scoped=scoped&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0571bdcd"]])

export default __exports__